import { useEffect, useState } from "react";
import FormInput from "../../molecules/FormInput";
import FormTemplate from "../../templates/FormTemplate";
import { Box, Grid, Stack } from "@mui/material";
import { SettingsService } from "../../../services/api";
import { useGlobalContext } from "../../../stores/Global";
import useRefresh from "../../../hooks/useRefresh";
import { useTranslation } from "react-i18next";
import { useMutationState } from "@tanstack/react-query";
import { useNavigate } from "react-router";
import FieldLabel from "../../atoms/FieldLabel";

export default function OpenAISettingsPage() {
  const { t } = useTranslation("Settings");
  const { context } = useGlobalContext();
  const refresh = useRefresh();
  const navigate = useNavigate();
  const [enabled, setEnabled] = useState(false);
  const [assistantId, setAssistantId] = useState("");
  const [key, setKey] = useState("");
  const [organizationId, setOrganizationId] = useState("");

  const [loading] = useMutationState({
    filters: { mutationKey: ["settings"] },
    select: (mutation) => mutation.state.status === "pending",
  });

  const handleSubmit = async () => {
    if (!context.settings) return;
    await SettingsService.updateSettings({
      appSettings: {
        ...context.settings,
        openai: {
          enabled,
          assistantId,
          apiKey: key,
          organizationId,
        },
      },
    });
    refresh();
  };

  const handleClose = () => {
    navigate(-1);
  };

  useEffect(() => {
    if (!context.settings) return;
    setEnabled(context.settings.openai.enabled);
    setAssistantId(context.settings.openai.assistantId);
    setKey(context.settings.openai.apiKey);
    setOrganizationId(context.settings.openai.organizationId);
  }, [context.settings]);

  return (
    <FormTemplate
      title={t("OpenAI.Title")}
      disableCancelButton
      submitButtonText={t("Save")}
      disableEnter
      onSubmit={handleSubmit}
      confirm
      loading={loading}
      onCancel={handleClose}
    >
      <Grid container alignItems={"center"} rowGap={3}>
        <Grid size={{ xs: 5, md: 3 }}>
          <FieldLabel children={t("Enabled")} />
        </Grid>
        <Grid size={{ xs: 7, md: 9 }}>
          <FormInput
            loading={loading}
            field="enabled"
            label={""}
            type="switch"
            value={enabled}
            onChange={(value) => setEnabled(value as boolean)}
          />
        </Grid>

        <Grid size={{ xs: 5, md: 3 }}>
          <FieldLabel children={t("AssistantID")} />
        </Grid>
        <Grid size={{ xs: 7, md: 3 }}>
          <FormInput
            loading={loading}
            field="assistantId"
            label={""}
            type="string"
            value={assistantId}
            onChange={(value) => setAssistantId(value.toString())}
          />
        </Grid>
        <Grid size={{ md: 1 }}>
          <Box />
        </Grid>

        <Grid size={{ xs: 5, md: 2 }}>
          <FieldLabel children={t("OrganizationID")} />
        </Grid>
        <Grid size={{ xs: 7, md: 3 }}>
          <FormInput
            loading={loading}
            field="organizationId"
            label={""}
            type="string"
            inputType="password"
            value={organizationId}
            onChange={(value) => setOrganizationId(value.toString())}
          />
        </Grid>

        <Grid size={{ xs: 5, md: 3 }}>
          <FieldLabel children={t("APIKey")} />
        </Grid>
        <Grid size={{ xs: 7, md: 9 }}>
          <FormInput
            loading={loading}
            field="apiKey"
            label={""}
            type="string"
            inputType="password"
            value={key}
            onChange={(value) => setKey(value.toString())}
          />
        </Grid>
      </Grid>
    </FormTemplate>
  );
}
